import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class HttpParamHelperService {

    constructor() {
    }

    public static createHttpParams(params: unknown): HttpParams {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(param => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }
}
